/**
 * 报纸-大样预览
 * 陈浩 2018-05-11 17:01:57
 */
'use strict';
angular.module('editCenNewspaperSampleDetailModule', [])
    .controller('editCenNewspaperSampleDetailCtrl', [
        '$scope',
        '$timeout',
        '$q',
        'storageListenerService',
        'editcenterRightsService',
        '$stateParams', '$state',
        'trsHttpService',
        'localStorageService',
        'modalDialog',
        'editNewspaperService',
        'editingCenterService',
        'publicToolService',
        function(
            $scope, 
            $timeout,
            $q,
            storageListenerService,
            editcenterRightsService,
            $stateParams,
            $state,
            trsHttpService,
            localStorageService,
            modalDialog,
            editNewspaperService,
            editingCenterService,
            publicToolService
        ) {

            initStatus();
            initData();

            /**
             * [initStatus description]
             * @return  {[type]}   [return description]
             */
            function initStatus() {
                $scope.status = {
                    picSize: [{
                        name: '10%',
                        value: 0
                    }, {
                        name: '25%',
                        value: 1
                    }, {
                        name: '33%',
                        value: 2
                    }, {
                        name: '50%',
                        value: 3
                    }, {
                        name: '65%',
                        value: 4
                    }, {
                        name: '80%',
                        value: 5
                    }, {
                        name: '100%',
                        value: 6
                    }, {
                        name: '125%',
                        value: 7
                    }, {
                        name: '150%',
                        value: 8
                    }, {
                        name: '200%',
                        value: 9
                    }, {
                        name: '250%',
                        value: 10
                    }, {
                        name: '300%',
                        value: 11
                    }, {
                        name: '350%',
                        value: 12
                    }, {
                        name: '400%',
                        value: 13
                    }],
                    currSize: {
                        name: '',
                        value: 6
                    },
                    sampleStatus: $stateParams.status,
                    hasSave: !!$stateParams.composeId,
                    showStyle: {},
                    isPdf: !!(Number($stateParams.status) === 42 || Number($stateParams.status) === 45),
                    isChrome: true,
                    sampledetailUrl: '/newmanageconfig/#/comments?composeId=' + $state.params.composeId
                };
                $scope.data = {
                };
            }

            /**
             * [initData description]
             * @return  {[type]}   [return description]
             */
            function initData() {
                browserIsChrome();
                // pdf
                if ($scope.status.isPdf && $scope.status.isChrome){
                    var params = {
                        ServiceId: 'mlf_paper',
                        MethodName: 'findImageOfComposePage',
                        Width: 224,
                        ComposeId: $stateParams.composeId,
                        IsPdf: 1
                    };
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/imgcenter.do', params, 'get').then(function() {
                        $timeout(function(){
                            $scope.data = {
                                imgSrc: '/wcm/imgcenter.do?ServiceId=mlf_paper&MethodName=findImageOfComposePage&Width=224&ComposeId=' + $stateParams.composeId + '&IsPdf=1#view=Fit', // #view=Fit
                                id: $stateParams.composeId,
                                positon: $stateParams.DIECINAME + ' -' + $stateParams.PAGENAME
                            };
                        });
                    });
                    setPdfBoxHeight();
                } else {// 图片
                    if (!!$stateParams.composeId) {
                        $scope.data = {
                            imgSrc: '/wcm/imgcenter.do?ServiceId=mlf_paper&MethodName=findImageOfComposePage&Width=0&ComposeId=' + $stateParams.composeId,
                            id: $stateParams.composeId,
                            positon: $stateParams.DIECINAME + ' -' + $stateParams.PAGENAME
                        };
                    } else {
                        $scope.data = {
                            imgSrc: decodeURIComponent($stateParams.src),
                            positon: $stateParams.diePosition + ' -' + $stateParams.banPositon
                        };
                    }
                    getRealWidth();
                }
                getRights();
            }

            /**
             * [getRights description] 获取操作权限
             * @return {[type]} [description]
             */
            function getRights() {
            // 按钮权限
                editcenterRightsService.initNewspaperListBtn('paper.dysy', $state.params.paperid).then(function(data) {
                    if (!data['paper.dysy.chakan']) {
                        modalDialog.alertType('', '您没有查看该页面的权限', 'error', false);
                        setTimeout(() => {
                            window.close();
                        }, 2000);
                    } else {
                        $scope.status.btnRights = data;
                    }
                });
                publicToolService.getModeconfiguration('IM').then((config) => {
                    $scope.status.IM = config;
                });
            }

            /**
             * [getRights description] 设置pdf盒子高度
             * @return {[type]} [description]
             */
            function setPdfBoxHeight() {
                var showAbleHeight = document.body.clientHeight - 70;
                $timeout(function(){
                    $scope.status.showStyle = {
                        height: showAbleHeight + 'px',
                    };
                });

            }

            /**
             * [getRealWidth description] 获取图片真实宽度
             * @return {[type]} [description]
             */
            function getRealWidth() {
                var img = new Image();
                img.src = $scope.data.imgSrc;
                img.onload = function() {
                    var showAbleHeight = document.body.clientHeight - 70;
                    var scaleNum = img.height / showAbleHeight;
                    $timeout(function(){
                        $scope.data.imgRealWidth = img.width;
                        $scope.status.showStyle = {
                            height: showAbleHeight + 'px',
                            width: img.width / scaleNum + 'px'
                        };
                    });

                };
                img.onerror = function() {
                };
            }

            /**
             * [getWidth description] 获取图片显示宽度
             * @return {[type]} [description]
             */
            function setImgWidth() {
                var width = ($scope.data.imgRealWidth * Number($scope.status.currSize.name.replace(/%/, '')) / 100);
                $scope.status.showStyle = {
                    width: width + 'px'
                };
            }

            /*
            * [closePage description]关闭当前页面
            */
            $scope.closePage = function() {
                window.close();
            };

            /**
             * [toSize description] 调整图片大小
             * @param  {[type]} num [description] 1 -1
             * @return {[type]}     [description]
             */
            $scope.toSize = function(num) {
                var index = $scope.status.currSize.value + Number(num);
                if (index > 13 || index < 0) {
                    index = $scope.status.currSize.value;
                    return;
                }
                $scope.status.currSize = $scope.status.picSize[index];
                setImgWidth();
            };

            /**
             * [toSize description] 点击下拉调整图片大小
             * @return {[type]}     [description]
             */
            $scope.changeSize = function(){
                setImgWidth();
            };

            /**
             * [pageup description] 翻页
             * @param  {[type]} num [description]
             * @return {[type]}     [description]
             */
            $scope.pageup = function(num) {
                var arr = JSON.parse(localStorageService.get('newspaperDYPreview'));
                let index;
                if (!arr || !arr.length) {return;}
                var attr = !!$stateParams.composeId ? 'COMPOSEPAGEINFOID' : 'imgSrc';
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i][attr] === $scope.data[attr] || arr[i][attr] === $scope.data.id) {
                        index = i;
                        break;
                    }
                }
                let nextIndex = index + Number(num);
                if (nextIndex >= arr.length) {
                    modalDialog.alertType('没有下一篇', '', 'warning');
                    return;
                } else if (nextIndex < 0) {
                    modalDialog.alertType('没有上一篇', '', 'warning');
                    return;
                }
                let composePageinfoid = arr[nextIndex].COMPOSEPAGEINFOID;
                $scope.data.id = composePageinfoid;
                if (!!$stateParams.composeId) {
                    $state.go($state.current.name, { composeId: arr[nextIndex].COMPOSEPAGEINFOID, DIECINAME: arr[nextIndex].DIECINAME, PAGENAME: arr[nextIndex].PAGENAME, status: arr[nextIndex].STATUS }, {
                        reload: false
                    });
                } else {
                    $state.go($state.current.name, { src: encodeURIComponent(arr[nextIndex].imgSrc), banPositon: arr[nextIndex].banPositon, diePosition: arr[nextIndex].diePosition }, {
                        reload: false
                    });
                }
                $scope.data.positon = arr[nextIndex].DIECINAME + ' -' + arr[nextIndex].PAGENAME;
                $scope.status.sampledetailUrl = '/newmanageconfig/#/comments?composeId=' + composePageinfoid;
            };

            /**
             * [options description] 评审意见
             * @return {[type]} [description]
             */
            $scope.options = function() {
                var arr = JSON.parse(localStorageService.get('newspaperDYPreview'));
                var index = getLocation(arr);
                editNewspaperService.textDesignation($state.params.composeId, arr[index].DYFILEPATH, $scope.status.btnRights['paper.dysy.reviewopinions']);
            };

            /**
             * [getLocation description]获取缓存,定位当前页面的index
             * @param  {[type]}  arr   [arr description]
             * @return  {[type]}   [return description]
             */
            function getLocation(arr) {
                if (!arr || !arr.length) {return;}
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].COMPOSEPAGEINFOID === $scope.data.id) {
                        return i;
                    }
                }
            }

            /**
             * [process description] 流程
             * @return {[type]} [description]
             */
            $scope.process = function() {
                editNewspaperService.processRecording();
            };

            /**
             * [sign description] 签发
             * @return {[type]} [description]
             */
            $scope.sign = function() {
                checkSign('该大样不是“组版完毕”状态，不能进行签发', '42').then(function(ids) {
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'dyExamine',
                        PaperId: $state.params.paperid,
                        ObjectIds: ids,
                        isPass: 'true'
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                        modalDialog.alertType('签发成功', '', 'success', false, function() {
                            storageListenerService.addListenerToNewspaper();
                            window.close();
                        });
                    });
                });
            };

            /**
             * [cancelSign description] 取消签发
             * @return {[type]} [description]
             */
            $scope.cancelSign = function() {
                checkSign('该大样不是“已审核”状态，不能取消签发', '45').then(function(ids) {
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'dyExamine',
                        PaperId: $state.params.paperid,
                        ObjectIds: ids,
                        isPass: 'false'
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                        modalDialog.alertType('取消签发成功', '', 'success', false, function() {
                            storageListenerService.addListenerToNewspaper();
                            window.close();
                        });
                    });
                });
            };

            /**
             * [checkSign description]检查可签发/取消签发 的状态
             * @param  {[type]}  tip   [tip description]
             * @param  {[type]}  status   [status description]
             * @return  {[type]}   [return description]
             */
            function checkSign(tip, status) {
                var deffer = $q.defer();
                if ($state.params.status !== status) {
                    modalDialog.alertType(tip, '', 'warning', 'confirm', function() {
                        deffer.reject();
                    });
                } else {
                    deffer.resolve($state.params.composeId);
                }
                return deffer.promise;
            }

            /**
             * [enforcedUlock description] 强制解锁
             * @return {[type]} [description]
             */
            $scope.enforcedUlock = function() {
                modalDialog.alertType('确定要强制解锁么？', '', 'ask', true, function() {
                    var params = {
                        serviceid: 'mlf_paper',
                        methodname: 'stopDaYangCompose',
                        ComposeIds: $state.params.composeId,
                        PaperId: $state.params.paperid
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                        modalDialog.alertType('强制解锁成功！', '', 'success', false);
                    });
                });
            };

            /**
             * [getUserBrowser description] 判断用户是否是谷歌浏览器
             * @return {[type]} [description]
             */
            function browserIsChrome(){
                var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
                $scope.status.isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1; // 判断Chrome浏览器
            }

            /**
             * [sendmessage 发送到IM]
             * @return  {[type]}  [return description]
             */
            $scope.sendmessage = function() {
                let messageBody = [];
                let messageType = 'DA_YANG';
                let outerSourceId = '';
                var arr = JSON.parse(localStorageService.get('newspaperDYPreview'));
                var index = getLocation(arr);
                let extraInfo = angular.extend(arr[index], {
                    daYangPic: '/wcm/imgcenter.do?ServiceId=mlf_paper&MethodName=findImageOfComposePage&Width=224&ComposeId=' + arr[index].COMPOSEPAGEINFOID + '&random=' + arr[index].RANDOMFORIMG,
                    oprType: 'paper.dysy'
                });
                let message = {
                    content: '',
                    extraInfo: JSON.stringify(extraInfo),
                    messageType: messageType, 
                    outerSourceId: outerSourceId,
                    title: $state.params.DIECINAME + '-' + $state.params.PAGENAME
                };
                messageBody.push(message);
                const info = {
                    messageBody: messageBody,
                    outerSourceId: '',
                    oprType: 'paper.dysy',
                    objId: $state.params.paperid
                };
                editingCenterService.sendToStudio(info);
            };
        }]);
